/* istanbul ignore file */
import { DropdownMenu } from 'framework/ui/menu';
import React from 'react';
import IconButton from '@mui/material/IconButton';
import PayrollReportStateToggler from 'domain/finance/payroll/generatedPayrolls/shared/Settings/PayrollReportStateToggler';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';

const PayrollReportSettings = () => {
  return (
    <DropdownMenu
      popupId="payroll-reports-settings"
      iconButton={
        <IconButton className="dropdown-toggle">
          <SettingsIcon />
        </IconButton>
      }
    >
      <PayrollReportStateToggler />
    </DropdownMenu>
  );
};

export default PayrollReportSettings;
